<template>

  <!-- <v-footer
    absolute
    dark
  >

    <v-card>
      <v-layout
        align-center
        justify-center
        row
        fill-height
      >
        <v-flex
          v-for="(image, i) in images"
          :key="i"
          md6
        >
          <v-img
            :src="require('@/assets/'+image)"
            max-height="50px"
            pa-1
          >
          </v-img>
        </v-flex>
      </v-layout>
    </v-card>
    <v-card
      flat
      tile
      class="primary lighten-1 white--text text-xs-center"
    >

      <v-card-text class="white--text pt-0">
        * This web site is designed for general information only. The information presented at this site should not be construed to be formal medical advice nor the formation of a doctor/patient relationship. These pages illustrate typical results of some plastic surgery procedures. Results will vary. The outcome of any plastic surgery procedure depends on the particulars of each patient’s individual case. In providing the photos and statements on this web site does not state or imply any guarantee.
      </v-card-text>
      <v-card-text class="white--text pt-0">
        <h3>© 2019 SIMONI PLASTIC SURGERY, INC </h3>
        <h3>421 N RODEO DR, SUITE G8, BEVERLY HILLS, CA 90210</h3>
        <router-link to="tel:+13103601360">
          <h3 class="white--text">(310) 360-1360</h3>
        </router-link>
        <SocialMedia />
      </v-card-text>
    </v-card>
  </v-footer> -->

  <div>
    <v-footer
      dark
      height="auto"
    >
      <v-card
        flat
        tile
        class="primary lighten-1 white--text text-xs-center"
      >
        <v-card-text>
          <img
            v-for="(image, i) in images"
            :key="i"
            :src="require('@/assets/'+ image)"
            style="padding: 5px; max-height:75px"
          >
        </v-card-text>

        <v-card-text class="white--text pt-0">
          * This web site is designed for general information only. The information presented at this site should not be construed to be formal medical advice nor the formation of a doctor/patient relationship. These pages illustrate typical results of some plastic surgery procedures. Results will vary. The outcome of any plastic surgery procedure depends on the particulars of each patient’s individual case. In providing the photos and statements on this web site does not state or imply any guarantee.
        </v-card-text>
        <v-card-text class="white--text pt-0">
          <h3>© 2019 SIMONI PLASTIC SURGERY, INC </h3>
          <h3>421 N RODEO DR, SUITE G8, BEVERLY HILLS, CA 90210</h3>
          <router-link to="tel:+13103601360">
            <h3 class="white--text">(310) 360-1360</h3>
          </router-link>
          <SocialMedia />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text class="white--text">
          &copy;2018 <strong>Simoni Plastic Surgery. All Rights Reserved.</strong>
        </v-card-text>
        <v-layout
          justify-center
          row
          wrap
        >

          <v-flex
            primary
            lighten-5
            py-3
            text-xs-center
            white--text
            xs12
          >
            <v-btn
            v-for="link in links"
            :key="link"
            color="white"
            flat
            round
          >
            {{ link.title }}
          </v-btn>
          </v-flex>
        </v-layout>

      </v-card>

    </v-footer>
  </div>
</template>

<script>
export default {
  components: {
    SocialMedia: () => import('@/components/SocialMedia')
  },
  data () {
    return {
      images: ['logo-footer-01.jpg', 'logo-footer-02.jpg', 'logo-footer-03.jpg', 'logo-footer-04.jpg', 'logo-footer-05.jpg'],
      links: [
        { title: 'Procedures', path: '/procedures', icon: 'dashboard' },
        { title: 'Rodeo Skin Spa', path: '/rodeo-skin-spa', icon: 'dashboard' },
        { title: 'Before & After Photos', path: '/before-after', icon: 'dashboard' },
        { title: 'Patient Reviews', path: '/patient-reviews', icon: 'dashboard' },
        { title: 'Contact', path: '/contact', icon: 'dashboard' }
      ]
    }
  }
}
</script>
<style scoped>
a {
  text-decoration: none;
}
</style>
